module.exports = __webpack_public_path__ + "media/src/images/icon__sad--3--dark-fdca95e059c48d208665d2e655301991.png";